// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_vm-0";
export var checkoutRateBadgeLink = "_vm-1";